/**
 * Characters that draw as nothing, or as something other than themselves: control characters (NUL
 * from `%00` among them), format characters (zero-width spaces and joiners, direction marks) and
 * lone surrogates.
 */
const UNPRINTABLE = /[\p{Cc}\p{Cf}\p{Cs}]/u;

/**
 * I-1537 (EM-19, `docs/concept-failure-messages.md`): the part of an address a not-found page may
 * quote back — an item key, a path, a work-area reference — or null when it may not, and the copy
 * says "at this address" instead.
 *
 * Null for a part that is empty, only white space, or holds any unprintable character. Quoted, such
 * a part drew as nothing: `/-/items/%00` read "No item  here" and "has no item .". It is dropped
 * rather than shown escaped (`\u0000`): an escape means nothing to a reader, and the address is in
 * the browser's bar for anyone who wants it. Nor is it quoted with the unprintable characters taken
 * out: `I-1%00` cleaned is `I-1`, and "has no item I-1" may name an item that exists.
 */
export function quotableAddressPart(part: string | null | undefined): string | null {
  if (!part || !part.trim() || UNPRINTABLE.test(part)) return null;
  return part;
}
